import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

// ── Estilos reutilizables ──────────────────────────────────────────────────

const HEADER = {
  font:      { bold: true, color: { argb: "FFFFFFFF" }, size: 11 },
  fill:      { type: "pattern", pattern: "solid", fgColor: { argb: "FF1677FF" } },
  alignment: { horizontal: "center", vertical: "middle", wrapText: true },
  border:    { bottom: { style: "thin", color: { argb: "FFD9D9D9" } } },
};
const SUBHEADER = {
  font:      { bold: true, size: 10 },
  fill:      { type: "pattern", pattern: "solid", fgColor: { argb: "FFE6F4FF" } },
  alignment: { horizontal: "left", vertical: "middle" },
};
const ALT_FILL  = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF9FAFB" } };
const TITLE_FONT = { bold: true, size: 14, color: { argb: "FF1677FF" } };
const MUTED_FONT = { size: 9, color:  { argb: "FF8C8C8C" } };

const styleRow = (row, alt) => {
  row.eachCell({ includeEmpty: true }, (cell) => {
    cell.alignment = { vertical: "middle", wrapText: false };
    if (alt) cell.fill = ALT_FILL;
  });
};

// ── Glosario de los 35 indicadores ────────────────────────────────────────

const GLOSARIO = [
  { indicador: "Ingresos",              modulo: "Seguridad",         fuente: "sec_user_token_hist — eventos de sesión (trigger)" },
  { indicador: "Log legacy",            modulo: "Seguridad",         fuente: "sc_log — sesiones sistema anterior" },
  { indicador: "Acciones plataforma",   modulo: "Seguridad",         fuente: "sc_logPoa — acciones con IP y módulo" },
  { indicador: "Cohortes",              modulo: "Cohortes",          fuente: "uni_cohortes" },
  { indicador: "Cambios cohortes",      modulo: "Cohortes",          fuente: "uni_cohortes_log" },
  { indicador: "Docs manifestación",    modulo: "Documentos",        fuente: "documentos_manifestacion_interes" },
  { indicador: "Docs eliminados",       modulo: "Documentos",        fuente: "documentos_manifestacion_interes_log" },
  { indicador: "Acciones EDAH",         modulo: "EDAH",              fuente: "edah_log" },
  { indicador: "ECAs creadas",          modulo: "ECAs",              fuente: "ecas_participantes.usercreate" },
  { indicador: "ECAs actualizadas",     modulo: "ECAs",              fuente: "ecas_participantes.userupdate" },
  { indicador: "ECAs eliminadas",       modulo: "ECAs",              fuente: "ecas_participantes.userdelete" },
  { indicador: "Enfoques",              modulo: "Enfoques",          fuente: "enfoque_tema" },
  { indicador: "Insumos informe",       modulo: "Informes",          fuente: "inf_insumos (FK int)" },
  { indicador: "Vistos buenos",         modulo: "Informes",          fuente: "inf_visto_bueno" },
  { indicador: "Soportes informe",      modulo: "Informes",          fuente: "inf_soporte (FK int)" },
  { indicador: "IPPTA registros",       modulo: "IPPTA",             fuente: "ippta_general" },
  { indicador: "IPPTA eliminados",      modulo: "IPPTA",             fuente: "ippta_log_eliminacion" },
  { indicador: "Novedades",             modulo: "Novedades",         fuente: "novedad" },
  { indicador: "Soportes novedades",    modulo: "Novedades",         fuente: "novedad_soporte" },
  { indicador: "Novedades eliminadas",  modulo: "Novedades",         fuente: "historial_novedad" },
  { indicador: "Validaciones POA",      modulo: "Validaciones",      fuente: "historico_validaciones.usuario_sistema" },
  { indicador: "Auditoría MER",         modulo: "MER",               fuente: "org_mer_auditoria" },
  { indicador: "Soportes MER",          modulo: "MER",               fuente: "org_soporte_mer" },
  { indicador: "MER eliminados",        modulo: "MER",               fuente: "org_soporte_mer_historial" },
  { indicador: "Archivos POA",          modulo: "POA",               fuente: "poa_archivos (FK int)" },
  { indicador: "Docs POA",              modulo: "POA",               fuente: "poa_documentos_medios" },
  { indicador: "Hist. docs POA",        modulo: "POA",               fuente: "poa_documentos_medios_historico" },
  { indicador: "Eliminaciones POA",     modulo: "POA",               fuente: "poa_trazabilidad_eliminacion" },
  { indicador: "Soportes PP",           modulo: "Planes de Pago",    fuente: "pp_soporte" },
  { indicador: "Repo docs",             modulo: "Repositorio",       fuente: "repo_documentos" },
  { indicador: "Repo favoritos",        modulo: "Repositorio",       fuente: "repo_documentos_favorito (FK int)" },
  { indicador: "Repo historial",        modulo: "Repositorio",       fuente: "repo_documentos_historico" },
  { indicador: "Fin. histórico",        modulo: "Financiero",        fuente: "fin_historico" },
  { indicador: "Caracterización",       modulo: "Caracterización",   fuente: "Temporal_Caracterizacion_2 (por email)" },
];

const fmt = (date) => date ? new Date(date).toLocaleString("es-CO") : "—";

// ── 1. Exportar TODOS los usuarios (resumen consolidado) ──────────────────

export const exportAllUsersExcel = async (data = [], filename) => {
  const wb = new ExcelJS.Workbook();
  wb.creator = "Plataforma BODECOM";
  wb.created = new Date();

  // ── Hoja 1: Resumen consolidado ────────────────────────────────────────
  const ws1 = wb.addWorksheet("Resumen Consolidado");

  ws1.columns = [
    { header: "Login",                    key: "login",                                    width: 22 },
    { header: "Nombre",                   key: "name",                                     width: 32 },
    { header: "Entidad",                  key: "entidad",                                  width: 10 },
    { header: "Estado",                   key: "active",                                   width: 10 },
    { header: "Rol",                      key: "role",                                     width: 16 },
    { header: "Email",                    key: "email",                                    width: 30 },
    { header: "Último ingreso",           key: "ultimo_login",                             width: 22 },
    { header: "Última IP",                key: "ultima_ip",                                width: 18 },
    { header: "Ingresos",                 key: "total_ingresos",                           width: 12 },
    { header: "Log legacy",               key: "total_log_legacy",                         width: 12 },
    { header: "Acciones plataforma",      key: "total_acciones_plataforma",                width: 18 },
    { header: "Cohortes",                 key: "total_cohortes",                           width: 12 },
    { header: "Cambios cohortes",         key: "total_cohortes_log",                       width: 16 },
    { header: "Docs manifestación",       key: "total_documentos_manifestacion",           width: 18 },
    { header: "Docs eliminados",          key: "total_documentos_manifestacion_eliminados", width: 16 },
    { header: "Acciones EDAH",            key: "total_edah_acciones",                      width: 14 },
    { header: "ECAs creadas",             key: "total_ecas_creadas",                       width: 13 },
    { header: "ECAs actualizadas",        key: "total_ecas_actualizadas",                  width: 16 },
    { header: "ECAs eliminadas",          key: "total_ecas_eliminadas",                    width: 14 },
    { header: "Enfoques",                 key: "total_enfoques",                           width: 12 },
    { header: "Insumos informe",          key: "total_insumos_inf",                        width: 14 },
    { header: "Vistos buenos",            key: "total_visto_bueno",                        width: 14 },
    { header: "Soportes informe",         key: "total_inf_soportes",                       width: 14 },
    { header: "IPPTA registros",          key: "total_ippta",                              width: 14 },
    { header: "IPPTA eliminados",         key: "total_ippta_eliminaciones",                width: 16 },
    { header: "Novedades",                key: "total_novedades",                          width: 12 },
    { header: "Soportes novedades",       key: "total_novedades_soportes",                 width: 16 },
    { header: "Novedades eliminadas",     key: "total_novedad_historial_eliminados",        width: 18 },
    { header: "Validaciones POA",         key: "total_historico_validaciones",             width: 16 },
    { header: "Auditoría MER",            key: "total_auditoria_mer",                      width: 14 },
    { header: "Soportes MER",             key: "total_soportes_mer",                       width: 14 },
    { header: "MER eliminados",           key: "total_soportes_mer_eliminados",            width: 14 },
    { header: "Archivos POA",             key: "total_poa_archivos",                       width: 14 },
    { header: "Docs POA",                 key: "total_poa_documentos",                     width: 12 },
    { header: "Hist. docs POA",           key: "total_poa_documentos_historico",           width: 14 },
    { header: "Elimin. POA",              key: "total_poa_eliminaciones",                  width: 13 },
    { header: "Soportes PP",              key: "total_pp_soportes",                        width: 13 },
    { header: "Repo docs",                key: "total_repo_documentos",                    width: 12 },
    { header: "Repo favoritos",           key: "total_repo_favoritos",                     width: 14 },
    { header: "Repo historial",           key: "total_repo_historico",                     width: 14 },
    { header: "Fin. histórico",           key: "total_fin_historico",                      width: 14 },
    { header: "Caracterización",          key: "total_caracterizacion_temp",               width: 16 },
  ];

  const h1 = ws1.getRow(1);
  h1.height = 34;
  h1.eachCell({ includeEmpty: true }, (cell) => Object.assign(cell, HEADER));

  data.forEach((row, i) => {
    const r = ws1.addRow({
      ...row,
      active:       row.active === "Y" ? "Activo" : row.active === "N" ? "Inactivo" : "—",
      ultimo_login: fmt(row.ultimo_login),
    });
    r.height = 20;
    styleRow(r, i % 2 === 1);
  });

  ws1.autoFilter = { from: { row: 1, column: 1 }, to: { row: 1, column: ws1.columns.length } };
  ws1.views = [{ state: "frozen", ySplit: 1 }];

  // ── Hoja 2: Indicadores (glosario) ────────────────────────────────────
  const ws2 = wb.addWorksheet("Indicadores");
  ws2.columns = [
    { header: "Indicador",     key: "indicador", width: 30 },
    { header: "Módulo",        key: "modulo",    width: 22 },
    { header: "Fuente en BD",  key: "fuente",    width: 52 },
  ];
  const h2 = ws2.getRow(1);
  h2.height = 34;
  h2.eachCell({ includeEmpty: true }, (cell) => Object.assign(cell, HEADER));

  GLOSARIO.forEach((row, i) => {
    const r = ws2.addRow(row);
    r.height = 20;
    styleRow(r, i % 2 === 1);
  });
  ws2.views = [{ state: "frozen", ySplit: 1 }];

  const buffer = await wb.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
    filename || `reporte_accesos_${Date.now()}.xlsx`
  );
};

// ── 2. Exportar trazabilidad de UN usuario ────────────────────────────────

export const exportUserTraceExcel = async (traceData, filename) => {
  const wb  = new ExcelJS.Workbook();
  wb.creator = "Plataforma BODECOM";
  wb.created  = new Date();
  const u   = traceData.usuario || {};
  const tot = traceData.totales  || {};

  // ── Hoja 1: Perfil y totales ──────────────────────────────────────────
  const ws1 = wb.addWorksheet("Perfil y Totales");
  ws1.getColumn(1).width = 30;
  ws1.getColumn(2).width = 42;

  ws1.mergeCells("A1:B1");
  const titleCell = ws1.getCell("A1");
  titleCell.value = `Trazabilidad — ${u.name || ""} (@${u.login || ""})`;
  titleCell.font  = TITLE_FONT;
  titleCell.alignment = { horizontal: "left", vertical: "middle" };
  ws1.getRow(1).height = 28;

  ws1.mergeCells("A2:B2");
  ws1.getCell("A2").value = `Generado: ${fmt(traceData.generado_en)}`;
  ws1.getCell("A2").font  = MUTED_FONT;
  ws1.getRow(2).height = 16;
  ws1.addRow([]);

  // Perfil
  const perfil = [
    ["Login",          u.login],
    ["Nombre",         u.name],
    ["Email",          u.email],
    ["Entidad",        u.entidad],
    ["Rol",            u.role],
    ["Estado",         u.active === "Y" ? "Activo" : "Inactivo"],
    ["MFA",            u.mfa_habilitado ? "Habilitado" : "Deshabilitado"],
    ["Último ingreso", fmt(u.last_login)],
    ["Última IP",      u.last_ip],
  ];
  const phRow = ws1.addRow(["PERFIL DEL USUARIO", ""]);
  phRow.eachCell({ includeEmpty: true }, (cell) => Object.assign(cell, SUBHEADER));
  phRow.height = 22;
  perfil.forEach(([campo, valor], i) => {
    const r = ws1.addRow([campo, valor || "—"]);
    r.height = 18;
    styleRow(r, i % 2 === 1);
  });

  ws1.addRow([]);

  // Totales por módulo
  const totTitle = ws1.addRow(["INDICADOR", "MÓDULO", "TOTAL"]);
  totTitle.eachCell({ includeEmpty: true }, (cell) => Object.assign(cell, HEADER));
  totTitle.height = 28;
  ws1.getColumn(3).width = 14;

  const MODULO_MAP = {
    ingresos: "Seguridad", log_legacy: "Seguridad", acciones_plataforma: "Seguridad",
    cohortes: "Cohortes", cohortes_log: "Cohortes",
    documentos_manifestacion: "Documentos", documentos_manifestacion_eliminados: "Documentos",
    edah_acciones: "EDAH",
    ecas_participantes: "ECAs",
    enfoques: "Enfoques",
    insumos_inf: "Informes", visto_bueno: "Informes", visto_bueno_historico: "Informes", inf_soportes: "Informes",
    ippta_registros: "IPPTA", ippta_eliminaciones: "IPPTA",
    novedades: "Novedades", novedades_soportes: "Novedades", novedad_historial_eliminados: "Novedades",
    historico_validaciones: "Validaciones",
    auditoria_mer: "MER", soportes_mer: "MER", soportes_mer_historial: "MER",
    poa_archivos: "POA", poa_documentos: "POA", poa_documentos_historico: "POA", poa_reemplazos: "POA", poa_eliminaciones: "POA",
    pp_soportes: "Planes de Pago",
    repo_documentos: "Repositorio", repo_favoritos: "Repositorio", repo_historico: "Repositorio",
    fin_historico: "Financiero",
    caracterizacion_temporal: "Caracterización",
  };

  Object.entries(tot).forEach(([key, val], i) => {
    const r = ws1.addRow([key.replace(/_/g, " "), MODULO_MAP[key] || "—", val]);
    r.height = 18;
    styleRow(r, i % 2 === 1);
    r.getCell(3).alignment = { horizontal: "center" };
    if (Number(val) > 0) r.getCell(3).font = { bold: true, color: { argb: "FF1677FF" } };
  });

  // ── Hoja 2: Actividad detallada (todos los registros) ─────────────────
  const ws2 = wb.addWorksheet("Actividad Detallada");
  ws2.columns = [
    { header: "Módulo",        key: "modulo",  width: 26 },
    { header: "Origen",        key: "origen",  width: 32 },
    { header: "Fecha",         key: "fecha",   width: 22 },
    { header: "Tipo / Acción", key: "tipo",    width: 20 },
    { header: "Descripción",   key: "desc",    width: 55 },
    { header: "IP / Ref.",     key: "ip",      width: 20 },
  ];
  const h2 = ws2.getRow(1);
  h2.height = 34;
  h2.eachCell({ includeEmpty: true }, (cell) => Object.assign(cell, HEADER));
  ws2.views = [{ state: "frozen", ySplit: 1 }];

  let rowIdx = 0;
  const addRows = (records, modulo, origen, getFecha, getTipo, getDesc, getIp) => {
    (records || []).forEach((rec) => {
      const r = ws2.addRow({
        modulo, origen,
        fecha: fmt(getFecha ? getFecha(rec) : null),
        tipo:  getTipo ? (getTipo(rec) || "—") : "—",
        desc:  getDesc ? (getDesc(rec) || "—") : "—",
        ip:    getIp   ? (getIp(rec)   || "—") : "—",
      });
      r.height = 18;
      styleRow(r, rowIdx % 2 === 1);
      rowIdx++;
    });
  };

  addRows(traceData.historial_ingresos,              "Seguridad",          "sec_user_token_hist",                  r => r.fecha_ingreso,   r => r.action_type,    r => r.dispositivo,                        r => r.ip);
  addRows(traceData.log_legacy,                      "Seguridad",          "sc_log",                               r => r.fecha,           r => r.action,         r => r.description,                       r => r.ip);
  addRows(traceData.acciones_plataforma,             "Seguridad",          "sc_logPoa",                            r => r.fecha,           r => r.action,         r => `${r.application}: ${r.description}`, r => r.ip);
  addRows(traceData.cohortes,                        "Cohortes",           "uni_cohortes",                         r => r.fechaRegistro,   () => "REGISTRO",      () => "Cohorte asignada",                  null);
  addRows(traceData.cohortes_log,                    "Cohortes",           "uni_cohortes_log",                     r => r.fechaActualizacion, r => r.tipo,         null,                                      null);
  addRows(traceData.documentos_manifestacion,        "Documentos",         "documentos_manifestacion_interes",     r => r.fecha_documento, () => "SUBIDA",        r => r.nameResource,                       null);
  addRows(traceData.documentos_manifestacion_eliminados, "Documentos",     "documentos_manifestacion_interes_log", r => r.fecha_eliminacion, () => "ELIMINADO",   r => r.nombre_archivo,                     null);
  addRows(traceData.edah_acciones,                   "EDAH",               "edah_log",                             r => r.fecha,           r => r.accion,         r => r.medicion,                           r => r.ip);
  addRows(traceData.ecas_participantes,              "ECAs",               "ecas_participantes",                   r => r.fecha_registro,  r => r.rol_usuario,    r => r.nombreeca,                          null);
  addRows(traceData.enfoques_registrados,            "Enfoques",           "enfoque_tema",                         r => r.fecha,           null,                  r => r.nombre,                             null);
  addRows(traceData.insumos_inf,                     "Informes",           "inf_insumos",                          r => r.fecha_creacion,  null,                  r => `${r.nombre_modulo} — ${r.periodo}`,  null);
  addRows(traceData.visto_bueno,                     "Informes",           "inf_visto_bueno",                      r => r.fechaRegistro,   null,                  r => r.nombre_modulo,                      null);
  addRows(traceData.inf_soportes,                    "Informes",           "inf_soporte",                          r => r.fecha_creacion,  null,                  r => r.nombre_soporte,                     null);
  addRows(traceData.ippta_registros,                 "IPPTA",              "ippta_general",                        r => r.fechaRegistro,   () => "REGISTRO",      r => `${r.participante} — ${r.nombre_proyecto || ""}`, null);
  addRows(traceData.ippta_eliminaciones,             "IPPTA",              "ippta_log_eliminacion",                r => r.fecha,           () => "ELIMINADO",     null,                                      r => r.ip);
  addRows(traceData.novedades,                       "Novedades",          "novedad",                              r => r.fecha_registro,  r => r.tipo_novedad,   r => r.observacion,                        null);
  addRows(traceData.novedades_soportes,              "Novedades",          "novedad_soporte",                      r => r.fecha_registro,  r => r.tipo_soporte,   r => r.nombre_real,                        null);
  addRows(traceData.novedad_historial_eliminados,    "Novedades",          "historial_novedad",                    r => r.fecha,           () => "ELIMINADO",     null,                                      null);
  addRows(traceData.historico_validaciones,          "Validaciones POA",   "historico_validaciones",               r => r.fecha_cambio,    r => r.campo,          r => `${r.valor_anterior} → ${r.valor_nuevo}`, null);
  addRows(traceData.auditoria_mer,                   "MER",                "org_mer_auditoria",                    r => r.fecha,           r => r.campo_modificado, r => `${r.valor_anterior} → ${r.valor_nuevo}`, null);
  addRows(traceData.soportes_mer,                    "MER",                "org_soporte_mer",                      r => r.fecha_creacion,  () => "SUBIDA",        r => r.nombre_soporte,                     null);
  addRows(traceData.soportes_mer_historial,          "MER",                "org_soporte_mer_historial",            r => r.fecha_eliminacion, () => "ELIMINADO",   r => r.nombre_soporte,                     null);
  addRows(traceData.poa_archivos,                    "POA",                "poa_archivos",                         r => r.fecha_creacion,  () => "ARCHIVO",       r => r.nombre_original,                    null);
  addRows(traceData.poa_documentos,                  "POA",                "poa_documentos_medios",                r => r.fecha_carga,     r => r.typeAction,     r => r.nameResource || r.nombre_archivo,   null);
  addRows(traceData.poa_documentos_historico,        "POA",                "poa_documentos_medios_historico",      r => r.fecha,           () => "HISTORIAL",     null,                                      null);
  addRows(traceData.poa_eliminaciones,               "POA",                "poa_trazabilidad_eliminacion",          r => r.fechaEliminacion, () => "ELIMINADO",   r => r.observacion,                        null);
  addRows(traceData.pp_soportes,                     "Planes de Pago",     "pp_soporte",                           r => r.fecha_creacion,  null,                  r => `${r.nombre} — ${r.nombre_proyecto || ""}`, null);
  addRows(traceData.repo_documentos,                 "Repositorio",        "repo_documentos",                      r => r.created_at,      r => r.type,           r => r.name,                               r => r.ip_address);
  addRows(traceData.repo_favoritos,                  "Repositorio",        "repo_documentos_favorito",             null,                   () => "FAVORITO",      r => r.nombre_recurso,                     null);
  addRows(traceData.repo_historico,                  "Repositorio",        "repo_documentos_historico",            r => r.fecha,           r => r.accion,         r => r.nombre_recurso,                     r => r.ip_address);
  addRows(traceData.fin_historico,                   "Financiero",         "fin_historico",                        r => r.fecha,           r => r.operacion,      r => `${r.tabla}.${r.campo}: ${r.valor_anterior || "—"} → ${r.valor_nuevo || "—"}`, null);
  addRows(traceData.caracterizacion_temporal,        "Caracterización",    "Temporal_Caracterizacion_2",           r => r.created_at,      r => r.estado_procesamiento, r => `${r.nombre || ""} ${r.apellido || ""} — ${r.nombre_proyecto || ""}`, null);

  ws2.autoFilter = { from: { row: 1, column: 1 }, to: { row: 1, column: 6 } };

  const buffer = await wb.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
    filename || `trazabilidad_${Date.now()}.xlsx`
  );
};
